import { useDispatch } from 'react-redux';
import './css/app.css';
import './css/main.css';
import './css/common.css';
import './css/payment.css';
import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { change_Current_Location, changeHeaderTitle } from '../store';
import axios from 'axios';
import { LoadingModal, MessageModal } from './component/modal/modal';
// bank 리스트 예시
import bank from './bankList';

function CreateMerchant() {
    let navigate = useNavigate();
    let dispatch = useDispatch();

    // 로딩 및 메시지 모달용 상태
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");

    // 요청 중복 방지
    const [isSubmitting, setIsSubmitting] = useState(false);

    const initFormData = {
        사업자등록번호: "",
        상호명: "",
        대표자명: "",
        연락처: "",
        사업장주소: "",
        정산은행: "",
        계좌번호: "",
        예금주: "",
        세금계산서Email: ""
    }
    const [formData, setFormData] = useState(initFormData);

    // 반응형 처리용 (예시)
    const [Window, setWindow] = useState(true);

    useEffect(() => {
        // 헤더나 위치 표시 부분
        dispatch(change_Current_Location("가맹점등록폼"));
        dispatch(
            changeHeaderTitle({
                mainTitle: "가맹점등록폼",
                subTitle: "",
            })
        );

        setLoading(false);

        // 반응형 처리
        const handleResize = () => {
            if (window.innerWidth >= 1280) setWindow(true);
            else setWindow(false);
        };
        window.addEventListener("resize", handleResize);
        handleResize();

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [dispatch]);

    // input 값 변경 핸들러
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    // 등록 버튼 클릭 시
    const onSubmit = async () => {
        if (isSubmitting) return; // 중복 요청 방지
        setIsSubmitting(true);
        setLoading(true);

        try {
            // 예시로 POST 요청
            let res = await axios.post('/api/merchant/create', formData);
            // 성공 시 처리
            setMessage("등록 성공!");
            setLoading(false);
            setIsSubmitting(false);
            // 페이지 이동 등
            // navigate("/some-page");
        } catch (error) {
            console.error(error);
            setMessage("등록 실패: " + (error?.response?.data?.message || error.message));
            setLoading(false);
            setIsSubmitting(false);
        }
    };

    // 취소 버튼 클릭 시
    const handleCancel = () => {
        setFormData(initFormData)
    };

    return (
        <div className="flex overflow-hidden">
            {loading && <LoadingModal />}
            <MessageModal message={message} />

            <div className="content" id="contents">
                <div className="payment">
                    <div className="inner-wrap h-full">
                        <div
                            className="content-wrap h-full"
                            style={{ padding: "0", gap: "20px" }}
                        >
                            <div
                                className="intro-y box"
                                style={{
                                    height: Window ? "" : "calc(100dvh - 4.5rem)",
                                    minHeight: "620px",
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        gap: "10px",
                                        alignItems: "center",
                                        padding: "0px",
                                        borderBottom: "1px solid #E5E5E5",
                                        backgroundColor: "#fff",
                                        marginBottom: "15px"
                                    }}
                                >
                                    <button
                                        className="tab-btn active"
                                        style={{
                                            padding: "12px 10px 8px",
                                            fontSize: "17px",
                                            fontWeight: "600",
                                            color: "#222",
                                            background: "transparent",
                                            border: "none",
                                            borderBottom: "3px solid #3182F6",
                                            transition: "all 0.2s ease-in-out",
                                            cursor: "pointer",
                                        }}
                                    >
                                        가맹점 등록 신청
                                    </button>
                                </div>
                                <div
                                    style={{
                                        padding: '0 0 0.5rem',
                                        height: "625px",
                                        overflowY: "auto",
                                        fontSize: "12px",
                                        display: 'flex',
                                        flexDirection: "column",
                                    }}
                                >
                                    <div className="list-info-box">
                                        <div className="gap" style={{ borderTop: "1px solid #e1e1e1" }}>
                                            <ul>
                                                {/* 사업자등록번호 */}
                                                <li>
                                                    <div className="inner" style={{ width: "100%" }}>
                                                        <span className="left-text" style={{ width: "125px", height: "36px" }}>
                                                            사업자등록번호
                                                        </span>
                                                        <input
                                                            id="사업자등록번호"
                                                            name="사업자등록번호"
                                                            type="text"
                                                            className="right-text"
                                                            style={{
                                                                width: "calc(100% - 127px)",
                                                                border: "none",
                                                                outline: "none"
                                                            }}
                                                            maxLength="20"
                                                            value={formData.사업자등록번호}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </li>
                                                {/* 상호명 */}
                                                <li>
                                                    <div className="inner" style={{ width: "100%" }}>
                                                        <span className="left-text" style={{ width: "125px", height: "36px" }}>
                                                            상호명
                                                        </span>
                                                        <input
                                                            id="상호명"
                                                            name="상호명"
                                                            type="text"
                                                            className="right-text"
                                                            style={{
                                                                width: "calc(100% - 127px)",
                                                                border: "none",
                                                                outline: "none"
                                                            }}
                                                            maxLength="30"
                                                            value={formData.상호명}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </li>
                                                {/* 대표자명 */}
                                                <li>
                                                    <div className="inner" style={{ width: "100%" }}>
                                                        <span className="left-text" style={{ width: "125px", height: "36px" }}>
                                                            대표자명
                                                        </span>
                                                        <input
                                                            id="대표자명"
                                                            name="대표자명"
                                                            type="text"
                                                            className="right-text"
                                                            style={{
                                                                width: "calc(100% - 127px)",
                                                                border: "none",
                                                                outline: "none"
                                                            }}
                                                            maxLength="30"
                                                            value={formData.대표자명}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </li>
                                                {/* 연락처 */}
                                                <li>
                                                    <div className="inner" style={{ width: "100%" }}>
                                                        <span className="left-text" style={{ width: "125px", height: "36px" }}>
                                                            연락처
                                                        </span>
                                                        <input
                                                            id="연락처"
                                                            name="연락처"
                                                            type="text"
                                                            className="right-text"
                                                            style={{
                                                                width: "calc(100% - 127px)",
                                                                border: "none",
                                                                outline: "none"
                                                            }}
                                                            maxLength="15"
                                                            placeholder="예: 01012345678"
                                                            value={formData.연락처}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </li>
                                                {/* 사업장주소 */}
                                                <li>
                                                    <div className="inner" style={{ width: "100%" }}>
                                                        <span className="left-text" style={{ width: "125px", height: "36px" }}>
                                                            사업장주소
                                                        </span>
                                                        <input
                                                            id="사업장주소"
                                                            name="사업장주소"
                                                            type="text"
                                                            className="right-text"
                                                            style={{
                                                                width: "calc(100% - 127px)",
                                                                border: "none",
                                                                outline: "none"
                                                            }}
                                                            maxLength="15"
                                                            placeholder=""
                                                            value={formData.사업장주소}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </li>
                                                {/* 정산은행 */}
                                                <li>
                                                    <div className="inner" style={{ width: "100%" }}>
                                                        <span className="left-text" style={{ width: "125px", height: "36px" }}>
                                                            정산은행
                                                        </span>
                                                        <select
                                                            id="정산은행"
                                                            name="정산은행"
                                                            className="right-text"
                                                            style={{
                                                                width: "calc(100% - 127px)",
                                                                border: "none",
                                                                outline: "none"
                                                            }}
                                                            value={formData.정산은행}
                                                            onChange={handleChange}
                                                        >
                                                            {bank.map((item, i) => (
                                                                <option key={i} value={item.name}>
                                                                    {item.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </li>
                                                {/* 계좌번호 */}
                                                <li>
                                                    <div className="inner" style={{ width: "100%" }}>
                                                        <span className="left-text" style={{ width: "125px", height: "36px" }}>
                                                            계좌번호
                                                        </span>
                                                        <input
                                                            id="계좌번호"
                                                            name="계좌번호"
                                                            type="text"
                                                            className="right-text"
                                                            style={{
                                                                width: "calc(100% - 127px)",
                                                                border: "none",
                                                                outline: "none"
                                                            }}
                                                            value={formData.계좌번호}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </li>
                                                {/* 예금주 */}
                                                <li>
                                                    <div className="inner" style={{ width: "100%" }}>
                                                        <span className="left-text" style={{ width: "125px", height: "36px" }}>
                                                            예금주
                                                        </span>
                                                        <input
                                                            id="예금주"
                                                            name="예금주"
                                                            type="text"
                                                            className="right-text"
                                                            style={{
                                                                width: "calc(100% - 127px)",
                                                                border: "none",
                                                                outline: "none"
                                                            }}
                                                            value={formData.예금주}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </li>
                                                {/* 세금계산서Email */}
                                                <li>
                                                    <div className="inner" style={{ width: "100%" }}>
                                                        <span className="left-text" style={{ width: "125px", height: "36px" }}>
                                                            세금계산서Email
                                                        </span>
                                                        <input
                                                            id="세금계산서Email"
                                                            name="세금계산서Email"
                                                            type="email"
                                                            className="right-text"
                                                            style={{
                                                                width: "calc(100% - 127px)",
                                                                border: "none",
                                                                outline: "none"
                                                            }}
                                                            maxLength="50"
                                                            placeholder="example@email.com"
                                                            value={formData.세금계산서Email}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="modal-footer" style={{ paddingRight: "5px" }}>
                                        <button
                                            type="button"
                                            className="btn btn-primary w-20 reg_btn"
                                            onClick={onSubmit}
                                            disabled={isSubmitting}
                                        >
                                            등록
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-primary w-20 close_btn"
                                            onClick={handleCancel}
                                            style={{
                                                backgroundColor: "darkred",
                                                marginLeft: "10px",
                                                border: "none"
                                            }}
                                        >
                                            취소
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CreateMerchant;
